var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.5C0.5 0.679688 1.15625 0 2 0H5.75V3C5.75 3.42188 6.07812 3.75 6.5 3.75H9.5V10.5C9.5 11.3438 8.82031 12 8 12H2C1.15625 12 0.5 11.3438 0.5 10.5V1.5ZM6.5 3V0L9.5 3H6.5Z",
    fill: "#D6D8E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.1f83acdc003ecc7748ec705f7655545f.svg";
export { ForwardRef as ReactComponent };